// extracted by mini-css-extract-plugin
export default {"container":"register_container__qLEZk","register":"register_register__okmoL","telephone":"register_telephone__G7KI3"};